import actionConstants from '../constants/';
import { matchesApiCancelKey } from '../apiCancelKeys';

const CLEARED_REQUEST_ID = '@payment/CLEARED_REQUEST';

const getTransactionList = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
  activeRequestId: '',
};

const getV3OrderList = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: [],
  errorMessage: '',
  activeRequestId: '',
};

const getTransactionFilterList = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
  activeRequestId: '',
};

const getTransactionDetails = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
  activeRequestId: '',
};

const GET_V3_ORDER_DETAILS = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
  activeRequestId: '',
};

const orderLevelSummary = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
  activeRequestId: '',
};
const getWalletNameFilterList = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: [],
  errorMessage: '',
  activeRequestId: '',
};

const settlementDetails = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
  activeRequestId: '',
};

const orderDetails = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
  activeRequestId: '',
};

const orderSummaryMetrics = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
  activeRequestId: '',
};

const orderRefundSettlement = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
  activeRequestId: '',
};

const pacbUploadInvoice = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const pacbInvoiceStatus = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
  activeRequestId: '',
};

const pacbUploadAwb = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const pacbAwbStatus = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
  activeRequestId: '',
};

const pacbBulkUpload = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const pacbBulkUploadHistory = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
  activeRequestId: '',
};

const initialState = {
  transactionList: { ...getTransactionList },
  getV3OrderList: { ...getV3OrderList },
  transactionFilterList: { ...getTransactionFilterList },
  transactionDetails: { ...getTransactionDetails },
  orderDetailsV3: { ...GET_V3_ORDER_DETAILS },
  orderLevelSummary: { ...orderLevelSummary },
  settlementDetails: { ...settlementDetails },
  orderDetails: { ...orderDetails },
  orderSummaryMetrics: { ...orderSummaryMetrics },
  orderRefundSettlement: { ...orderRefundSettlement },
  walletNamesList:{ ...getWalletNameFilterList},
  pacbUploadInvoice: { ...pacbUploadInvoice },
  pacbInvoiceStatus: { ...pacbInvoiceStatus },
  pacbUploadAwb: { ...pacbUploadAwb },
  pacbAwbStatus: { ...pacbAwbStatus },
  pacbBulkUpload: { ...pacbBulkUpload },
  pacbBulkUploadHistory: { ...pacbBulkUploadHistory },
};

const isStaleResponse = (
  activeRequestId: string,
  responseRequestId?: string
) => Boolean(activeRequestId && activeRequestId !== responseRequestId);

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function transactionReducer(state = initialState, action) {
  switch (action.type) {
    case actionConstants.GET_TRANSACTION_LIST_REQUEST:
      return {
        ...state,
        transactionList: {
          ...state.transactionList,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          activeRequestId: action.payload?.requestId ?? '',
        },
      };

    case actionConstants.GET_TRANSACTION_LIST_SUCCESS:
      if (
        isStaleResponse(
          state.transactionList.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        transactionList: {
          ...state.transactionList,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          activeRequestId: '',
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_TRANSACTION_LIST_FAILURE:
      if (
        isStaleResponse(
          state.transactionList.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        transactionList: {
          ...state.transactionList,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          activeRequestId: '',
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_TRANSACTION_LIST_CLEAR:
      return {
        ...state,
        transactionList: {
          ...initialState.transactionList,
          data: {},
          activeRequestId: CLEARED_REQUEST_ID,
        },
      };

    case actionConstants.GET_V3_ORDER_LIST_REQUEST:
      return {
        ...state,
        getV3OrderList: {
          ...state.getV3OrderList,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          activeRequestId: action.payload?.requestId ?? '',
        },
      };

    case actionConstants.GET_V3_ORDER_LIST_SUCCESS:
      if (
        isStaleResponse(
          state.getV3OrderList.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        getV3OrderList: {
          ...state.getV3OrderList,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          activeRequestId: '',
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_V3_ORDER_LIST_FAILURE:
      if (
        isStaleResponse(
          state.getV3OrderList.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        getV3OrderList: {
          ...state.getV3OrderList,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          activeRequestId: '',
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_V3_ORDER_LIST_CLEAR:
      return {
        ...state,
        getV3OrderList: {
          ...initialState.getV3OrderList,
          data: [],
          activeRequestId: CLEARED_REQUEST_ID,
        },
      };

    case actionConstants.CANCEL_API_REQUEST:
      return {
        ...state,
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.GET_TRANSACTION_LIST
        )
          ? {
              transactionList: {
                ...state.transactionList,
                isLoading: false,
                activeRequestId: CLEARED_REQUEST_ID,
              },
            }
          : {}),
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.GET_V3_ORDER_LIST
        )
          ? {
              getV3OrderList: {
                ...state.getV3OrderList,
                isLoading: false,
                activeRequestId: CLEARED_REQUEST_ID,
              },
            }
          : {}),
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.GET_ORDER_LEVEL_SUMMARY
        )
          ? {
              orderLevelSummary: {
                ...state.orderLevelSummary,
                isLoading: false,
                activeRequestId: CLEARED_REQUEST_ID,
              },
            }
          : {}),
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.GET_ORDER_DETAILS
        )
          ? {
              orderDetails: {
                ...state.orderDetails,
                isLoading: false,
                activeRequestId: CLEARED_REQUEST_ID,
              },
            }
          : {}),
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.GET_SETTLEMENT_DETAILS
        )
          ? {
              settlementDetails: {
                ...state.settlementDetails,
                isLoading: false,
                activeRequestId: CLEARED_REQUEST_ID,
              },
            }
          : {}),
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.GET_ORDER_REFUND_SETTLEMENT
        )
          ? {
              orderRefundSettlement: {
                ...state.orderRefundSettlement,
                isLoading: false,
                activeRequestId: CLEARED_REQUEST_ID,
              },
            }
          : {}),
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.GET_V3_ORDER_DETAILS
        )
          ? {
              orderDetailsV3: {
                ...state.orderDetailsV3,
                isLoading: false,
                activeRequestId: CLEARED_REQUEST_ID,
              },
            }
          : {}),
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.GET_TRANSACTION_DETAILS
        )
          ? {
              transactionDetails: {
                ...state.transactionDetails,
                isLoading: false,
                activeRequestId: CLEARED_REQUEST_ID,
              },
            }
          : {}),
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.GET_TRANSACTION_FILTER_LIST
        )
          ? {
              transactionFilterList: {
                ...state.transactionFilterList,
                isLoading: false,
                activeRequestId: CLEARED_REQUEST_ID,
              },
            }
          : {}),
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.GET_WALLET_NAME_FILTER_LIST
        )
          ? {
              walletNamesList: {
                ...state.walletNamesList,
                isLoading: false,
                activeRequestId: CLEARED_REQUEST_ID,
              },
            }
          : {}),
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.GET_ORDER_SUMMARY_METRICS
        )
          ? {
              orderSummaryMetrics: {
                ...state.orderSummaryMetrics,
                isLoading: false,
                activeRequestId: CLEARED_REQUEST_ID,
              },
            }
          : {}),
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.PACB_BULK_UPLOAD_HISTORY
        )
          ? {
              pacbBulkUploadHistory: {
                ...state.pacbBulkUploadHistory,
                isLoading: false,
                activeRequestId: CLEARED_REQUEST_ID,
              },
            }
          : {}),
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.PACB_GET_INVOICE_STATUS
        )
          ? {
              pacbInvoiceStatus: {
                ...state.pacbInvoiceStatus,
                isLoading: false,
                activeRequestId: CLEARED_REQUEST_ID,
              },
            }
          : {}),
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.PACB_GET_AWB_STATUS
        )
          ? {
              pacbAwbStatus: {
                ...state.pacbAwbStatus,
                isLoading: false,
                activeRequestId: CLEARED_REQUEST_ID,
              },
            }
          : {}),
      };

    case actionConstants.GET_TRANSACTION_FILTER_LIST_REQUEST:
      return {
        ...state,
        transactionFilterList: {
          ...state.transactionFilterList,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          activeRequestId: action.payload?.requestId ?? '',
        },
      };

    case actionConstants.GET_TRANSACTION_FILTER_LIST_SUCCESS:
      if (
        isStaleResponse(
          state.transactionFilterList.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        transactionFilterList: {
          ...state.transactionFilterList,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          activeRequestId: '',
        },
      };

    case actionConstants.GET_TRANSACTION_FILTER_LIST_FAILURE:
      if (
        isStaleResponse(
          state.transactionFilterList.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        transactionFilterList: {
          ...state.transactionFilterList,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          activeRequestId: '',
        },
      };

    case actionConstants.GET_TRANSACTION_FILTER_LIST_CLEAR:
      return {
        ...state,
        transactionFilterList: {
          ...initialState.transactionFilterList,
          data: {},
          activeRequestId: CLEARED_REQUEST_ID,
        },
      };

    case actionConstants.GET_TRANSACTION_DETAILS_REQUEST:
      return {
        ...state,
        transactionDetails: {
          ...state.transactionDetails,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          activeRequestId: action.payload?.requestId ?? '',
        },
      };

    case actionConstants.GET_TRANSACTION_DETAILS_SUCCESS:
      if (
        isStaleResponse(
          state.transactionDetails.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        transactionDetails: {
          ...state.transactionDetails,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          activeRequestId: '',
        },
      };

    case actionConstants.GET_TRANSACTION_DETAILS_FAILURE:
      if (
        isStaleResponse(
          state.transactionDetails.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        transactionDetails: {
          ...state.transactionDetails,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          activeRequestId: '',
        },
      };

    case actionConstants.GET_TRANSACTION_DETAILS_CLEAR:
      return {
        ...state,
        transactionDetails: {
          ...state.transactionDetails,
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
          activeRequestId: CLEARED_REQUEST_ID,
        },
      };

    case actionConstants.GET_V3_ORDER_DETAILS_REQUEST:
      return {
        ...state,
        orderDetailsV3: {
          ...state.orderDetailsV3,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          activeRequestId: action.payload?.requestId ?? '',
        },
      };
  
    case actionConstants.GET_V3_ORDER_DETAILS_SUCCESS:
      if (
        isStaleResponse(
          state.orderDetailsV3.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        orderDetailsV3: {
          ...state.orderDetailsV3,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          activeRequestId: '',
        },
      };
  
    case actionConstants.GET_V3_ORDER_DETAILS_FAILURE:
      if (
        isStaleResponse(
          state.orderDetailsV3.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        orderDetailsV3: {
          ...state.orderDetailsV3,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          activeRequestId: '',
        },
      };
  
    case actionConstants.GET_V3_ORDER_DETAILS_CLEAR:
      return {
        ...state,
        orderDetailsV3: {
          ...initialState.orderDetailsV3,
          data: {},
          activeRequestId: CLEARED_REQUEST_ID,
        },
      };

    case actionConstants.GET_ORDER_LEVEL_SUMMARY_REQUEST:
      return {
        ...state,
        orderLevelSummary: {
          ...state.orderLevelSummary,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          activeRequestId: action.payload?.requestId ?? '',
        },
      };
    case actionConstants.GET_WALLET_NAME_FILTER_LIST_REQUEST:
      return {
        ...state,
        walletNamesList: {
          ...state.walletNamesList,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          activeRequestId: action.payload?.requestId ?? '',
        },
      };

    case actionConstants.GET_ORDER_LEVEL_SUMMARY_SUCCESS:
      if (
        isStaleResponse(
          state.orderLevelSummary.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        orderLevelSummary: {
          ...state.orderLevelSummary,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          activeRequestId: '',
        },
      };
    case actionConstants.GET_WALLET_NAME_FILTER_LIST_SUCCESS:
      if (
        isStaleResponse(
          state.walletNamesList.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        walletNamesList: {
          ...state.walletNamesList,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          activeRequestId: '',
        },
      };

    case actionConstants.GET_ORDER_LEVEL_SUMMARY_FAILURE:
      if (
        isStaleResponse(
          state.orderLevelSummary.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        orderLevelSummary: {
          ...state.orderLevelSummary,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          activeRequestId: '',
        },
      };
    case actionConstants.GET_WALLET_NAME_FILTER_LIST_FAILURE:
      if (
        isStaleResponse(
          state.walletNamesList.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        walletNamesList: {
          ...state.walletNamesList,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          activeRequestId: '',
        },
      };

    case actionConstants.GET_ORDER_LEVEL_SUMMARY_CLEAR:
      return {
        ...state,
        orderLevelSummary: {
          ...initialState.orderLevelSummary,
          data: {},
          activeRequestId: CLEARED_REQUEST_ID,
        },
      };

    case actionConstants.GET_SETTLEMENT_DETAILS_REQUEST:
      return {
        ...state,
        settlementDetails: {
          ...state.settlementDetails,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          activeRequestId: action.payload?.requestId ?? '',
        },
      };

    case actionConstants.GET_SETTLEMENT_DETAILS_SUCCESS:
      if (
        isStaleResponse(
          state.settlementDetails.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        settlementDetails: {
          ...state.settlementDetails,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          activeRequestId: '',
        },
      };

    case actionConstants.GET_SETTLEMENT_DETAILS_FAILURE:
      if (
        isStaleResponse(
          state.settlementDetails.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        settlementDetails: {
          ...state.settlementDetails,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          activeRequestId: '',
        },
      };

    case actionConstants.GET_SETTLEMENT_DETAILS_CLEAR:
      return {
        ...state,
        settlementDetails: {
          ...initialState.settlementDetails,
          data: {},
          activeRequestId: CLEARED_REQUEST_ID,
        },
      };

    case actionConstants.GET_ORDER_DETAILS_REQUEST:
      return {
        ...state,
        orderDetails: {
          ...state.orderDetails,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          activeRequestId: action.payload?.requestId ?? '',
        },
      };

    case actionConstants.GET_ORDER_DETAILS_SUCCESS:
      if (
        isStaleResponse(
          state.orderDetails.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        orderDetails: {
          ...state.orderDetails,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          activeRequestId: '',
        },
      };

    case actionConstants.GET_ORDER_DETAILS_FAILURE:
      if (
        isStaleResponse(
          state.orderDetails.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        orderDetails: {
          ...state.orderDetails,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          activeRequestId: '',
        },
      };

    case actionConstants.GET_ORDER_DETAILS_CLEAR:
      return {
        ...state,
        orderDetails: {
          ...initialState.orderDetails,
          data: {},
          activeRequestId: CLEARED_REQUEST_ID,
        },
      };

    case actionConstants.GET_ORDER_SUMMARY_METRICS_REQUEST:
      return {
        ...state,
        orderSummaryMetrics: {
          ...state.orderSummaryMetrics,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          activeRequestId: action.payload?.requestId ?? '',
        },
      };

    case actionConstants.GET_ORDER_SUMMARY_METRICS_SUCCESS:
      if (
        isStaleResponse(
          state.orderSummaryMetrics.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        orderSummaryMetrics: {
          ...state.orderSummaryMetrics,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          activeRequestId: '',
        },
      };

    case actionConstants.GET_ORDER_SUMMARY_METRICS_FAILURE:
      if (
        isStaleResponse(
          state.orderSummaryMetrics.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        orderSummaryMetrics: {
          ...state.orderSummaryMetrics,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          activeRequestId: '',
        },
      };

    case actionConstants.GET_ORDER_SUMMARY_METRICS_CLEAR:
      return {
        ...state,
        orderSummaryMetrics: {
          ...initialState.orderSummaryMetrics,
          data: {},
          activeRequestId: CLEARED_REQUEST_ID,
        },
      };

    case actionConstants.GET_ORDER_REFUND_SETTLEMENT_REQUEST:
      return {
        ...state,
        orderRefundSettlement: {
          ...state.orderRefundSettlement,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          activeRequestId: action.payload?.requestId ?? '',
        },
      };

    case actionConstants.GET_ORDER_REFUND_SETTLEMENT_SUCCESS:
      if (
        isStaleResponse(
          state.orderRefundSettlement.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        orderRefundSettlement: {
          ...state.orderRefundSettlement,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          activeRequestId: '',
        },
      };

    case actionConstants.GET_ORDER_REFUND_SETTLEMENT_FAILURE:
      if (
        isStaleResponse(
          state.orderRefundSettlement.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        orderRefundSettlement: {
          ...state.orderRefundSettlement,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          activeRequestId: '',
        },
      };

    case actionConstants.GET_ORDER_REFUND_SETTLEMENT_CLEAR:
      return {
        ...state,
        orderRefundSettlement: {
          ...initialState.orderRefundSettlement,
          data: {},
          activeRequestId: CLEARED_REQUEST_ID,
        },
      };

    case actionConstants.GET_WALLET_NAME_FILTER_LIST_CLEAR:
       return {
        ...state,
        walletNamesList: {
          ...initialState.walletNamesList,
          data: [],
          activeRequestId: CLEARED_REQUEST_ID,
        },
      };

    case actionConstants.PACB_UPLOAD_INVOICE_REQUEST:
      return {
        ...state,
        pacbUploadInvoice: {
          ...state.pacbUploadInvoice,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.PACB_UPLOAD_INVOICE_SUCCESS:
      return {
        ...state,
        pacbUploadInvoice: {
          ...state.pacbUploadInvoice,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };
    case actionConstants.PACB_UPLOAD_INVOICE_FAILURE:
      return {
        ...state,
        pacbUploadInvoice: {
          ...state.pacbUploadInvoice,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };
    case actionConstants.PACB_UPLOAD_INVOICE_CLEAR:
      return {
        ...state,
        pacbUploadInvoice: {
          ...initialState.pacbUploadInvoice,
          data: {},
        },
      };

    case actionConstants.PACB_GET_INVOICE_STATUS_REQUEST:
      return {
        ...state,
        pacbInvoiceStatus: {
          ...state.pacbInvoiceStatus,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          activeRequestId: action.payload?.requestId ?? '',
        },
      };
    case actionConstants.PACB_GET_INVOICE_STATUS_SUCCESS:
      if (
        isStaleResponse(
          state.pacbInvoiceStatus.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        pacbInvoiceStatus: {
          ...state.pacbInvoiceStatus,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          activeRequestId: '',
        },
      };
    case actionConstants.PACB_GET_INVOICE_STATUS_FAILURE:
      if (
        isStaleResponse(
          state.pacbInvoiceStatus.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        pacbInvoiceStatus: {
          ...state.pacbInvoiceStatus,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          activeRequestId: '',
        },
      };
    case actionConstants.PACB_GET_INVOICE_STATUS_CLEAR:
      return {
        ...state,
        pacbInvoiceStatus: {
          ...initialState.pacbInvoiceStatus,
          data: {},
          activeRequestId: CLEARED_REQUEST_ID,
        },
      };

    case actionConstants.PACB_UPLOAD_AWB_REQUEST:
      return {
        ...state,
        pacbUploadAwb: {
          ...state.pacbUploadAwb,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.PACB_UPLOAD_AWB_SUCCESS:
      return {
        ...state,
        pacbUploadAwb: {
          ...state.pacbUploadAwb,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };
    case actionConstants.PACB_UPLOAD_AWB_FAILURE:
      return {
        ...state,
        pacbUploadAwb: {
          ...state.pacbUploadAwb,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };
    case actionConstants.PACB_UPLOAD_AWB_CLEAR:
      return {
        ...state,
        pacbUploadAwb: {
          ...initialState.pacbUploadAwb,
          data: {},
        },
      };

    case actionConstants.PACB_GET_AWB_STATUS_REQUEST:
      return {
        ...state,
        pacbAwbStatus: {
          ...state.pacbAwbStatus,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          activeRequestId: action.payload?.requestId ?? '',
        },
      };
    case actionConstants.PACB_GET_AWB_STATUS_SUCCESS:
      if (
        isStaleResponse(
          state.pacbAwbStatus.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        pacbAwbStatus: {
          ...state.pacbAwbStatus,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          activeRequestId: '',
        },
      };
    case actionConstants.PACB_GET_AWB_STATUS_FAILURE:
      if (
        isStaleResponse(
          state.pacbAwbStatus.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        pacbAwbStatus: {
          ...state.pacbAwbStatus,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          activeRequestId: '',
        },
      };
    case actionConstants.PACB_GET_AWB_STATUS_CLEAR:
      return {
        ...state,
        pacbAwbStatus: {
          ...initialState.pacbAwbStatus,
          data: {},
          activeRequestId: CLEARED_REQUEST_ID,
        },
      };

    case actionConstants.PACB_BULK_UPLOAD_REQUEST:
      return {
        ...state,
        pacbBulkUpload: {
          ...state.pacbBulkUpload,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.PACB_BULK_UPLOAD_SUCCESS:
      return {
        ...state,
        pacbBulkUpload: {
          ...state.pacbBulkUpload,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };
    case actionConstants.PACB_BULK_UPLOAD_FAILURE:
      return {
        ...state,
        pacbBulkUpload: {
          ...state.pacbBulkUpload,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };
    case actionConstants.PACB_BULK_UPLOAD_CLEAR:
      return {
        ...state,
        pacbBulkUpload: {
          ...initialState.pacbBulkUpload,
          data: {},
        },
      };

    case actionConstants.PACB_BULK_UPLOAD_HISTORY_REQUEST:
      return {
        ...state,
        pacbBulkUploadHistory: {
          ...state.pacbBulkUploadHistory,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          activeRequestId: action.payload?.requestId ?? '',
        },
      };
    case actionConstants.PACB_BULK_UPLOAD_HISTORY_SUCCESS:
      if (
        isStaleResponse(
          state.pacbBulkUploadHistory.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        pacbBulkUploadHistory: {
          ...state.pacbBulkUploadHistory,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          activeRequestId: '',
        },
      };
    case actionConstants.PACB_BULK_UPLOAD_HISTORY_FAILURE:
      if (
        isStaleResponse(
          state.pacbBulkUploadHistory.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        pacbBulkUploadHistory: {
          ...state.pacbBulkUploadHistory,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          activeRequestId: '',
        },
      };
    case actionConstants.PACB_BULK_UPLOAD_HISTORY_CLEAR:
      return {
        ...state,
        pacbBulkUploadHistory: {
          ...initialState.pacbBulkUploadHistory,
          data: {},
          activeRequestId: CLEARED_REQUEST_ID,
        },
      };

    default:
      return state;
  }
}
